import { collectRoutines } from '@ardoq/rxbeach';
import { handleFetchAll } from 'streams/crud/routines';
import { modelNamespace } from './actions';
import { modelApi } from '@ardoq/api';

export const routines = collectRoutines(
  handleFetchAll(modelNamespace, modelApi.fetchAll)
);
